export default __webpack_public_path__ + "static/media/rug4-min.b39af905.jpg";